import { useEffect, useState } from 'react';

/**
 * A hook that retains a local value until the parent prop is updated to match it.
 * Useful for controlled components with async state synchronization.
 **/
export const useRetainedValue = <T>(
	valueFromProp: T,
	setValueFromProp: (v: T) => void
) => {
	const [value, setValue] = useState<T>(valueFromProp);

	useEffect(() => {
		setValue(valueFromProp);
	}, [valueFromProp]);

	return [
		value,
		(v: T) => {
			setValue(v);
			setValueFromProp(v);
		},
	] as const;
};
